import BaseApi from '@/api/Base/BaseApi'
import { Category, ManualDetail } from '@/api/Manual/types'

const ROOT = '/manual'

export default class ManualApi extends BaseApi {
  getCategoryList(lang: 'ko' | 'en' = 'ko', keyword?: string) {
    return this.agent.get<Category[]>(`${ROOT}/category/list`, {
      params: {
        language: lang,
        search: keyword,
      },
    })
  }

  getManualDetail(manualId: string) {
    return this.agent.get<ManualDetail>(`${ROOT}/${manualId}`)
  }
}
